export default __webpack_public_path__ + "static/media/Groupe 8907.bac2df14.svg";